// extracted by mini-css-extract-plugin
module.exports = {"criteriaInput":"SearchBarCriteriaInput_criteriaInput__3BWE0","criteriaInputContainer":"SearchBarCriteriaInput_criteriaInputContainer__2DALy"};